import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "../address/AppBar";
import {useTheme} from "@material-ui/core";
import {AppTheme} from "../..";
import { Trans, useTranslation } from "react-i18next";
import { selectUserInfo } from "../userInfo/userInfoSlice";
import { useAppSelector } from "../../app/hooks";
import { useState } from "react";

// import RiskMapEditor from './RiskMapEditor';
import EventEditor from "./EventEditor";
import PerilAI from "./PerilAI";
import Perils from "./Perils";
import OverrideMapEditor from "./OverrideMapEditor";
import Link from "@mui/material/Link";

const drawerWidth = 250;

type EditorView = 'events' | 'perilAI' | 'perils' | 'overrides';

// TODO: navigation in main body with url change

export default function RiskEditor() {
    const theme = useTheme<AppTheme>();
    const { t } = useTranslation()
    const [currentView, setCurrentView] = useState<EditorView>('events');

    const style = {
      backgroundColor: theme.backgroundColor.primary,
      minHeight: "2.5rem",
      display: "flex",
      "justifyContent": "center",
    };

    const menuItemStyle = (isActive: boolean) => ({
        ...style,
        backgroundColor: isActive ? theme.backgroundColor.secondary : theme.backgroundColor.primary,
        cursor: 'pointer',
    });

    const renderContent = () => {
        switch (currentView) {
            case 'events':
                return <EventEditor />;
            case 'perilAI':
                return <PerilAI />;
            case 'perils':
                return <Perils />;
            case 'overrides':
                return <OverrideMapEditor />;
            default:
                return <EventEditor />;
        }
    };

    return <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
            title={t("applicationMenu.menuItem.riskEditor")}
            position="fixed"
            sx={{ zIndex: (theme: any) => theme.zIndex.drawer + 1 }}
        />
        <Box sx={{flex: 1, display: "flex"}}>
          <Drawer
              variant="permanent"
              sx={{
                  width: drawerWidth,
                  flexShrink: 0,
                  [`& .MuiDrawer-paper`]: {
                  width: drawerWidth,
                  boxSizing: "border-box",
                  },
              }}
          >
            <Box sx={{ paddingTop: 8 }}>
              <ul>
                <li style={menuItemStyle(currentView === 'events')} onClick={() => setCurrentView('events')}>
                  <span className="NavItemLink">
                    <p className="NavItemLabel">{t("blockTitle.event")}</p>
                  </span>
                </li>
                <li style={menuItemStyle(currentView === 'perilAI')} onClick={() => setCurrentView('perilAI')}>
                  <span className="NavItemLink">
                    <p className="NavItemLabel">{t("blockTitle.perilAI")}</p>
                  </span>
                </li>
                <li style={menuItemStyle(currentView === 'perils')} onClick={() => setCurrentView('perils')}>
                  <span className="NavItemLink">
                    <p className="NavItemLabel">{t("blockTitle.perils")}</p>
                  </span>
                </li>
                <li style={menuItemStyle(currentView === 'overrides')} onClick={() => setCurrentView('overrides')}>
                  <span className="NavItemLink">
                    <p className="NavItemLabel">Overrides</p>
                  </span>
                </li>
              </ul>
            </Box>
            {/* <Box sx={{ paddingLeft: "12px", paddingRight: "12px", paddingTop: 10 }} >
              Map
            </Box> */}
          </Drawer>
          <Box
              component="main"
              sx={{
                  flexGrow: 1,
                  paddingLeft: 3,
                  paddingRight: 3,
                  paddingTop: 10,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
              }}
          >
              {renderContent()}
          </Box>
        </Box>
      </Box>
}